import React, { FC, useEffect } from "react";

import { KpkMedia } from "@keepeek/commons";
import { BaseComponentProps } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";

import MediaDetailMetadataInfo from "../../../components/detail/MediaDetailMetadataInfo";
import { useElement } from "../../../providers/element/hooks";
import { WidgetUIState } from "../atoms";
import { useWidgetState } from "../hooks";
import { KWidgetWithElementProps } from "../models";

export type KSheetWidgetProps = {
  widgetId: string;
} & KWidgetWithElementProps &
  BaseComponentProps;

const KSheetWidget: FC<React.PropsWithChildren<KSheetWidgetProps>> = function ({
  elementId,
  className,
  testId = "KSheetWidget",
  type,
}) {
  let element: KpkMedia | undefined;
  // let's find element from state (TODO also get it from other state ?):
  const { element: elementFromDetail, fields } = useElement();
  const { setWidgetState, widgetState } = useWidgetState({
    id: "sheet",
    type,
  });

  if (elementFromDetail && elementFromDetail.id === elementId) {
    element = elementFromDetail;
  }

  useEffect(() => {
    if (!element || !fields) {
      setWidgetState({ state: WidgetUIState.NULL });
    } else {
      setWidgetState({ state: WidgetUIState.RENDERED });
    }
  }, [element, fields, setWidgetState]);

  if (!element || !fields) {
    return null;
  }

  if (widgetState.state === WidgetUIState.RENDERED) {
    return (
      <Box className={clsx("KSheetWidget", className)} data-testid={testId}>
        <MediaDetailMetadataInfo
          kpkMedia={element}
          fieldsSectionsToDisplay={fields.fieldsSectionsToDisplay}
        />
      </Box>
    );
  }
  return null;
};
export default KSheetWidget;
